// extracted by mini-css-extract-plugin
export default {"wrapper":"bD-z","response":"cD-z","error":"dD-z","disabled":"eD-z","buttons":"fD-z","feedbackQuestionSection":"gD-z","yesNoWrapper":"hD-z"};